import type { PatientNote } from '../../../services/patient/notes';

/**
 * Client-side note search — matches title or plain body text,
 * case-insensitively. Runs entirely in the component layer; the server
 * query and ordering are untouched.
 */
export function filterNotesByQuery(notes: PatientNote[], query: string): PatientNote[] {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return notes;

    return notes.filter(
        (note) =>
            note.title.toLowerCase().includes(normalizedQuery) ||
            note.body.toLowerCase().includes(normalizedQuery)
    );
}
